/*
  DKY | Video hemat data.

  MASALAH YANG DIPERBAIKI
  Section "grid geser" merender video hero seperti ini:

      <video preload="metadata" controls loop muted
             poster="...thumbnail...jpg">
        <source src="....HD-1080p-7.2Mbps-92149091.mp4">
      </video>

  Dua hal yang mahal di situ:

  1) Hanya ada SATU <source>, dan itu rendition 1080p 7,2 Mbps (13,6 MB).
     HP di jaringan 4G menarik file yang sama persis dengan desktop, padahal
     kotak videonya lebarnya cuma ~375px. Shopify sebenarnya sudah menyiapkan
     rendition 720p (8,6 MB) dan 480p (3,1 MB) untuk video yang sama.

  2) Alamat video sudah tertulis di HTML, jadi browser mulai menariknya
     sejak halaman dibaca - bahkan kalau kotaknya ada di dalam geseran yang
     belum kelihatan. Unduhan itu menahan peristiwa "load" halaman selama
     15-31 detik. Akibat lanjutannya cukup parah: skrip Zakeke dan Instafeed
     dijadwalkan di window.load, jadi tombol "Print Your Cat" baru hidup
     setelah ~31 detik.

  CARA MEMPERBAIKI
  Alamat video dilepas dari <video> sebelum browser sempat menariknya
  (memakai MutationObserver, jadi tertangkap saat halaman masih dibaca),
  lalu dipasang kembali hanya ketika kotaknya hampir masuk layar - dengan
  rendition yang sesuai ukuran layar.

  Poster tetap terpasang, jadi tampilan tidak berubah dan tidak ada
  pergeseran tata letak (CLS tetap 0).

  PENTING: skrip ini sengaja dimuat TANPA defer di <head>. Pengintainya harus
  sudah terpasang sebelum <video> dibaca browser; kalau memakai defer,
  unduhannya sudah terlanjur jalan. Ukurannya kecil (~4 KB, dilayani dari CDN
  Shopify yang sudah preconnect), jadi biaya blokirnya jauh lebih murah
  daripada 13,6 MB yang dihemat.

  Video yang BUKAN hiasan (pembungkusnya tidak data-autoplay="true") tidak
  dilepas alamatnya - hanya diturunkan ke preload="none" supaya tombol
  putarnya tetap berfungsi seperti biasa.

  Untuk mematikan: hapus satu baris <script> di layout/theme.liquid.
*/
(function () {
  if (window.__dkyVideoLite) return;
  window.__dkyVideoLite = true;

  /* ---------- Tangga rendition Shopify ----------
     Setiap video di Shopify dibuatkan beberapa rendition yang berbagi alamat
     dasar dan nomor pekerjaan yang sama, hanya potongan mutunya yang beda:

       ....HD-1080p-7.2Mbps-92149091.mp4
       ....HD-720p-4.5Mbps-92149091.mp4
       ....SD-480p-1.5Mbps-92149091.mp4

     Angka Mbps-nya tidak bebas - tiap mutu punya pasangan tetap. Tabel di
     bawah ini hasil pemeriksaan langsung ke Admin API atas seluruh video di
     toko ini. Kalau suatu saat ada tangga baru yang tidak terdaftar, alamat
     aslinya dipakai apa adanya (lihat retarget + jaring pengaman onerror),
     jadi videonya tetap jalan - cuma tidak ikut diperkecil. */
  var LADDERS = [
    { 'HD-1080p': '7.2', 'HD-720p': '4.5', 'SD-480p': '1.5' },
    { 'HD-1080p': '4.8', 'HD-720p': '3.0', 'SD-480p': '1.2' },
    { 'HD-1080p': '2.5', 'HD-720p': '1.6', 'SD-480p': '0.9' }
  ];

  var RENDITION = /(SD-480p|HD-720p|HD-1080p)-([0-9.]+)Mbps/;

  function ladderFor(tier, rate) {
    for (var i = 0; i < LADDERS.length; i++) {
      if (LADDERS[i][tier] === rate) return LADDERS[i];
    }
    return null;
  }

  function retarget(url, tier) {
    var m = url.match(RENDITION);
    if (!m) return url;                    // bukan video Shopify - biarkan
    var ladder = ladderFor(m[1], m[2]);
    if (!ladder || !ladder[tier]) return url;
    return url.replace(RENDITION, tier + '-' + ladder[tier] + 'Mbps');
  }

  /* ---------- Pilih mutu sesuai layar & jaringan ---------- */

  function wantedTier(video) {
    var c = navigator.connection || {};
    if (c.saveData) return 'SD-480p';
    if (/2g/.test(c.effectiveType || '')) return 'SD-480p';

    /* Lebar tampil dikali kerapatan piksel (dibatasi 2x - di atas itu mata
       sudah tidak bisa membedakan pada video bergerak). */
    var box = video.getBoundingClientRect().width || window.innerWidth || 1280;
    var need = box * Math.min(window.devicePixelRatio || 1, 2);

    if (need <= 900) return 'SD-480p';
    if (need <= 1400) return 'HD-720p';
    return 'HD-1080p';
  }

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* ---------- Lepas alamat sebelum browser menariknya ---------- */

  function isDecorative(video) {
    var wrap = video.closest ? video.closest('[data-video-wrap]') : null;
    return !!wrap && wrap.getAttribute('data-autoplay') === 'true';
  }

  function strip(video) {
    if (video.__dkyLite) return;
    video.__dkyLite = true;

    /* Video biasa (ada tombol putarnya): cukup jangan diunduh di depan.
       Alamatnya dibiarkan supaya tombol putar tetap berfungsi. */
    if (!isDecorative(video)) {
      video.setAttribute('preload', 'none');
      return;
    }

    var urls = [];
    var direct = video.getAttribute('src');
    if (direct) urls.push(direct);

    var sources = Array.prototype.slice.call(video.querySelectorAll('source'));
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i].getAttribute('src');
      if (s) urls.push(s);
      sources[i].parentNode.removeChild(sources[i]);
    }

    if (!urls.length) return;

    video.__dkyUrls = urls;
    video.removeAttribute('src');
    video.removeAttribute('autoplay');
    video.setAttribute('preload', 'none');

    /* Hiasan yang berputar sendiri tidak perlu bilah kontrol - itu sisa
       bawaan yang bikin bilah abu-abu nongol di HP. */
    video.removeAttribute('controls');
    video.muted = true;
    video.loop = true;
    video.setAttribute('playsinline', 'playsinline');

    /* Batalkan permintaan metadata yang mungkin sudah terlanjur jalan. */
    try { video.load(); } catch (e) {}

    watch(video);
  }

  /* ---------- Pasang kembali saat hampir kelihatan ---------- */

  function play(video) {
    if (reduceMotion) return;              // hormati setelan kurangi gerak
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* Pasang alamat lalu putar. play() sengaja TIDAK dipanggil persis setelah
     load(): datanya belum tentu siap dan browser membatalkan permintaannya
     (AbortError). Ditunggu sampai ada data yang bisa diputar dulu. */
  function loadAndPlay(video, url) {
    video.src = url;
    try { video.load(); } catch (e) {}
    if (video.readyState >= 2) play(video);
    else video.addEventListener('loadeddata', function () { play(video); }, { once: true });
  }

  function mount(video) {
    if (video.__dkyMounted) return;
    video.__dkyMounted = true;

    var original = video.__dkyUrls[0];
    var url = retarget(original, wantedTier(video));

    /* Jaring pengaman: kalau alamat hasil hitungan ternyata tidak ada,
       balik ke alamat asli dari tema. */
    if (url !== original) {
      var recovered = false;
      video.addEventListener('error', function () {
        if (recovered) return;
        recovered = true;
        loadAndPlay(video, original);
      });
    }

    loadAndPlay(video, url);
  }

  var io = null;
  if (window.IntersectionObserver) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var video = entries[i].target;
        if (entries[i].isIntersecting) {
          mount(video);
          if (video.__dkyMounted && video.paused) play(video);
        } else if (video.__dkyMounted && !video.paused) {
          /* Di luar layar: hentikan supaya tidak membakar baterai dan CPU. */
          video.pause();
        }
      }
    }, { rootMargin: '300px 0px' });
  }

  function watch(video) {
    if (io) io.observe(video);
    else mount(video);                     // browser lawas: pasang langsung
  }

  /* ---------- Pengintai ---------- */

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'VIDEO') { strip(root); return; }
    var list = root.querySelectorAll('video');
    for (var i = 0; i < list.length; i++) strip(list[i]);
  }

  /* Tertangkap saat halaman masih dibaca, jadi alamatnya lepas sebelum
     browser sempat menariknya. Inilah alasan skrip ini tidak pakai defer. */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Jaring susulan untuk apa pun yang lolos dari pengintai. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  /* Theme Editor merender ulang section tanpa memuat ulang halaman. */
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target || document);
  });
})();
